// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.play-container {
  background-color: white;
  padding: 40px 80px;
}

.play-container > h1 {
  color: #000;
  text-align: center;
  font-family: "Thicker";
  font-size: 48px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-transform: capitalize;
  text-align: left;
  width: max-content;
  border-bottom: 4px solid #ba1e24;
  padding-bottom: 5px;
}

.playground {
  margin-top: 40px;
}

/* ############################################# */
.content-container {
  width: 100%;
  display: flex;
  justify-content: center;
  height: 500px;
  gap: 10px;
}

.content-container > div {
  flex: 0 0 400px;
  border-radius: 0px;
  transition: 0.5s ease-in-out;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.play_heading {
  color: #fff;
  font-family: Thicker;
  font-size: 26px;
  font-style: normal;
  font-weight: 600;
  margin-left: 28px;
  margin-top: 440px;
}
.content-container > div:nth-of-type(1) {
  background: url("https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/dcNewImages/639x695_11zon+(1).webp")
    no-repeat 50% / cover;
}
.content-container > div:nth-of-type(2) {
  background: url("https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/devil_circuit/web-image+(2)_11zon.webp")
    no-repeat 50% / cover;
}
.content-container > div:nth-of-type(3) {
  background: url("https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/dcNewImages/639x695+(1)_11zon+(1).webp")
    no-repeat 50% / cover;
}

.content-container > div:nth-of-type(4) {
  background: url("https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/dcunder500/Rectangle+472.jpg")
    no-repeat 50% / cover;
}

.content {
  display: flex;
  align-items: center;
  padding: 15px;
  opacity: 0;
  flex-direction: column;
  height: 100%;
  justify-content: flex-end;
  background: #02022e;
  background: linear-gradient(
    0deg,
    rgba(2, 2, 46, 0.6755077031) 0%,
    rgba(255, 255, 255, 0) 100%
  );
  transform: translatey(100%);
  transition: opacity 0.1s ease-in-out, transform 0.4s 0.2s;
  visibility: hidden;
}

.content > h2 {
  width: 100%;
  color: #fff;
  font-family: "Thicker";
  font-size: 26px;
  font-style: normal;
  font-weight: 600;
  line-height: 100%;
  /* 26px */
  text-align: left;
  text-transform: capitalize;
}

.content > span {
  color: #fff;
  /* font-family: ; */
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  /* 21.6px */
  letter-spacing: -0.18px;
  margin-top: 20px;
}

.content > div {
  display: flex;
  justify-content: flex-start;
  width: 100%;
}

.content > div > button {
  margin: 35px 0px 20px 0px;
  color: #fff;
  font-family: "Thicker";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 126.6%;
  background: #ba1e24;
  padding: 11px 20px;
  border: none !important;
  /* 20.256px */
}

.content-container > div:hover {
  flex: 0 0 500px;
}

.content-container > div:hover .play_heading {
  display: none;
}

.content-container > div:hover .content {
  opacity: 1;
  transform: translatey(0%);
  visibility: visible;
}
.card-container {
  display: none;
}
@media screen and (max-width: 650px) {
  .content-container {
    display: none;
  }
  .play-container {
    padding: 10px 0px 10px 20px;
    overflow-x: scroll;
  }
  .play-container > h1 {
    color: #000;
    text-align: center;
    font-family: "Thicker";
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: capitalize;
    text-align: left;
    width: max-content;
    border-bottom: 4px solid #ba1e24;
    padding-bottom: 5px;
  }
  .card-container {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    overflow-x: auto;
    padding-bottom: 30px;
    margin-bottom: 12px;
    -webkit-overflow-scrolling: touch;
  }

  .card-container::-webkit-scrollbar {
    display: none;
  }

  .card-outerdiv {
    width: 80%;
    height: 400px;
    background-color: #f0f0f0;
    border-radius: 0px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    margin-right: 20px;
    overflow: hidden;
    position: relative;
  }

  .card-button {
    position: absolute;
    left: 20px;
    bottom: 20px;
    padding: 10px 20px;
    background-color: #ba1e24;
    color: #fff;
    border: none;
  }
  .name-desc {
    position: absolute;
    bottom: 80px;
    left: 10px;
    font-size: 14px;
    padding: 10px 10px;
    align-items: flex-start;
    color: #fff;
    border: none;
    font-family: 'lightThicker';
    line-height: normal;
    border-radius: 0px;
    text-align: start;
  }
  .name-heading {
    position: absolute;
    top: 70px;
    left: 10px;
    font-size: 16px;
    padding: 10px 10px;
    color: #fff;
    border: none;
    border-radius: 0px;
  }
  .card-outerdiv img {
    object-fit:contain;
  }
  .card-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
    padding: 20px;
    box-sizing: border-box;
    text-align: center;
  }
}

@media screen and (max-width: 1700px) {
  .content-container > div {
    flex: 0 0 330px !important;
  }
  .content-container > div:hover {
    flex: 0 0 400px !important;
  }
}

@media screen and (max-width: 1500px) {
  .content-container > div {
    flex: 0 0 20vw !important;
  }
  .content-container > div:hover {
    flex: 0 0 25vw !important;
  }
}


`, "",{"version":3,"sources":["webpack://./src/components/homepage/playground.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,kDAAkD;AAClD;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE;yBACuB;AACzB;AACA;EACE;yBACuB;AACzB;AACA;EACE;yBACuB;AACzB;;AAEA;EACE;yBACuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,UAAU;EACV,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB;;;;GAIC;EACD,2BAA2B;EAC3B,yDAAyD;EACzD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;EACX,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,aAAa;EACf;EACA;IACE,2BAA2B;IAC3B,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,0BAA0B;IAC1B,gBAAgB;IAChB,kBAAkB;IAClB,gCAAgC;IAChC,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,iCAAiC;EACnC;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;IACV,aAAa;IACb,yBAAyB;IACzB,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;AACF","sourcesContent":[".play-container {\n  background-color: white;\n  padding: 40px 80px;\n}\n\n.play-container > h1 {\n  color: #000;\n  text-align: center;\n  font-family: \"Thicker\";\n  font-size: 48px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  text-transform: capitalize;\n  text-align: left;\n  width: max-content;\n  border-bottom: 4px solid #ba1e24;\n  padding-bottom: 5px;\n}\n\n.playground {\n  margin-top: 40px;\n}\n\n/* ############################################# */\n.content-container {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  height: 500px;\n  gap: 10px;\n}\n\n.content-container > div {\n  flex: 0 0 400px;\n  border-radius: 0px;\n  transition: 0.5s ease-in-out;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n}\n\n.play_heading {\n  color: #fff;\n  font-family: Thicker;\n  font-size: 26px;\n  font-style: normal;\n  font-weight: 600;\n  margin-left: 28px;\n  margin-top: 440px;\n}\n.content-container > div:nth-of-type(1) {\n  background: url(\"https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/dcNewImages/639x695_11zon+(1).webp\")\n    no-repeat 50% / cover;\n}\n.content-container > div:nth-of-type(2) {\n  background: url(\"https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/devil_circuit/web-image+(2)_11zon.webp\")\n    no-repeat 50% / cover;\n}\n.content-container > div:nth-of-type(3) {\n  background: url(\"https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/dcNewImages/639x695+(1)_11zon+(1).webp\")\n    no-repeat 50% / cover;\n}\n\n.content-container > div:nth-of-type(4) {\n  background: url(\"https://spectacom-public-assets.s3.ap-south-1.amazonaws.com/dcunder500/Rectangle+472.jpg\")\n    no-repeat 50% / cover;\n}\n\n.content {\n  display: flex;\n  align-items: center;\n  padding: 15px;\n  opacity: 0;\n  flex-direction: column;\n  height: 100%;\n  justify-content: flex-end;\n  background: #02022e;\n  background: linear-gradient(\n    0deg,\n    rgba(2, 2, 46, 0.6755077031) 0%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  transform: translatey(100%);\n  transition: opacity 0.1s ease-in-out, transform 0.4s 0.2s;\n  visibility: hidden;\n}\n\n.content > h2 {\n  width: 100%;\n  color: #fff;\n  font-family: \"Thicker\";\n  font-size: 26px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 100%;\n  /* 26px */\n  text-align: left;\n  text-transform: capitalize;\n}\n\n.content > span {\n  color: #fff;\n  /* font-family: ; */\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 120%;\n  /* 21.6px */\n  letter-spacing: -0.18px;\n  margin-top: 20px;\n}\n\n.content > div {\n  display: flex;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n.content > div > button {\n  margin: 35px 0px 20px 0px;\n  color: #fff;\n  font-family: \"Thicker\";\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 126.6%;\n  background: #ba1e24;\n  padding: 11px 20px;\n  border: none !important;\n  /* 20.256px */\n}\n\n.content-container > div:hover {\n  flex: 0 0 500px;\n}\n\n.content-container > div:hover .play_heading {\n  display: none;\n}\n\n.content-container > div:hover .content {\n  opacity: 1;\n  transform: translatey(0%);\n  visibility: visible;\n}\n.card-container {\n  display: none;\n}\n@media screen and (max-width: 650px) {\n  .content-container {\n    display: none;\n  }\n  .play-container {\n    padding: 10px 0px 10px 20px;\n    overflow-x: scroll;\n  }\n  .play-container > h1 {\n    color: #000;\n    text-align: center;\n    font-family: \"Thicker\";\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    text-transform: capitalize;\n    text-align: left;\n    width: max-content;\n    border-bottom: 4px solid #ba1e24;\n    padding-bottom: 5px;\n  }\n  .card-container {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    overflow-x: auto;\n    padding-bottom: 30px;\n    margin-bottom: 12px;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .card-container::-webkit-scrollbar {\n    display: none;\n  }\n\n  .card-outerdiv {\n    width: 80%;\n    height: 400px;\n    background-color: #f0f0f0;\n    border-radius: 0px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-shrink: 0;\n    margin-right: 20px;\n    overflow: hidden;\n    position: relative;\n  }\n\n  .card-button {\n    position: absolute;\n    left: 20px;\n    bottom: 20px;\n    padding: 10px 20px;\n    background-color: #ba1e24;\n    color: #fff;\n    border: none;\n  }\n  .name-desc {\n    position: absolute;\n    bottom: 80px;\n    left: 10px;\n    font-size: 14px;\n    padding: 10px 10px;\n    align-items: flex-start;\n    color: #fff;\n    border: none;\n    font-family: 'lightThicker';\n    line-height: normal;\n    border-radius: 0px;\n    text-align: start;\n  }\n  .name-heading {\n    position: absolute;\n    top: 70px;\n    left: 10px;\n    font-size: 16px;\n    padding: 10px 10px;\n    color: #fff;\n    border: none;\n    border-radius: 0px;\n  }\n  .card-outerdiv img {\n    object-fit:contain;\n  }\n  .card-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0, 0, 0, 0.4);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    color: #fff;\n    padding: 20px;\n    box-sizing: border-box;\n    text-align: center;\n  }\n}\n\n@media screen and (max-width: 1700px) {\n  .content-container > div {\n    flex: 0 0 330px !important;\n  }\n  .content-container > div:hover {\n    flex: 0 0 400px !important;\n  }\n}\n\n@media screen and (max-width: 1500px) {\n  .content-container > div {\n    flex: 0 0 20vw !important;\n  }\n  .content-container > div:hover {\n    flex: 0 0 25vw !important;\n  }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
